import SearchFilter from './SearchFilter';
import {
  invoiceFilterSel,
  nardFilterSel,
  orderNumberFilterSel,
  poNumberFilterSel
} from 'src/store/modules/invoices';

import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({
  invoiceFilter: invoiceFilterSel(state),
  nardFilter: nardFilterSel(state),
  orderNumberFilter: orderNumberFilterSel(state),
  poNumberFilter: poNumberFilterSel(state)
});

export default connect(mapStateToProps, null)(SearchFilter);
